import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export interface StoreSelectOption {
    value: string;
    label: string;
}

/** Selector del sistema de diseño. Sustituye al select nativo en la tienda. */
export function StoreSelect({
    id,
    ariaLabel,
    value,
    options,
    onChange,
    placeholder = 'Elige',
}: {
    id?: string;
    ariaLabel: string;
    value: string;
    options: readonly StoreSelectOption[];
    onChange: (value: string) => void;
    placeholder?: string;
}) {
    const current = options.find((option) => option.value === value);
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    id={id}
                    type="button"
                    variant="outline"
                    size="sm"
                    className="w-full justify-between font-normal"
                    aria-label={ariaLabel}
                >
                    <span className="truncate">{current?.label ?? placeholder}</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="max-h-72 w-[var(--radix-dropdown-menu-trigger-width)] overflow-y-auto">
                {options.map((option) => (
                    <DropdownMenuItem key={option.value || 'empty'} onSelect={() => onChange(option.value)}>
                        {option.label}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
